import React from "react";
import { useNotificationHistory } from "./hooks/useNotificationHistory";
import SuggestionListing from "@/components/suggestions/SuggestionListing";
import CardSection from "./CardSection";

interface Props {
  username: string;
  timeline: {
    QuarterStart: string;
    QuarterEnd: string;
  };
  display: { NotificationHistory: boolean };
}

const cardBase = "bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md p-4";

const NotificationHistoryCard: React.FC<Props> = ({ username, timeline, display }) => {
  const enabled = !!username && !!timeline && display.NotificationHistory;
  const { loading, suggestions } = useNotificationHistory(username, timeline, enabled);

  if (!display.NotificationHistory) return null;

  return (
    <div className="col-span-12">
      {loading ? (
        <div className={`${cardBase} text-center`}>
          <div className="animate-spin inline-block w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full"></div>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Loading Notification History...
          </p>
        </div>
      ) : suggestions && suggestions.length > 0 ? (
        <CardSection title="Checkpoint and Quarter Notification History">
          <div className="col-span-12">
            <SuggestionListing
              items={suggestions}
              RefreshData={() => {}}
              showCategoriesOnListing={true}
              showDocuSignMessage={true}
              adminMode={false}
              readOnly={true}
            />
          </div>
        </CardSection>
      ) : (
        <div className={`${cardBase} italic text-gray-500 dark:text-gray-400`}>
          No notification history found for this quarter.
        </div>
      )}
    </div>
  );
};

export default NotificationHistoryCard;